import * as React from "react";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";
import Link from "@mui/material/Link"

const item: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 5,
  boxShadow: 6,
  borderRadius: 2,
  textDecoration: 'none'
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: "flex", overflow: "hidden", bgcolor: "secondary.light" }}
    >
      <Container sx={{ mt: {xs: 15,sm: 25}, mb: {xs: 15,sm: 30}, display: "flex", position: "relative" }}>
        <Box
          component="img"
          src="/productCurvyLines.png"
          alt="curvy lines"
          sx={{ pointerEvents: "none", position: "absolute", top: -180 }}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={item} component={Link} href="/academics">
              <Box
                component="img"
                src="/open-book.png"
                alt="books"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                Academics
              </Typography>
              <Typography variant="h5" align='center'>
                {
                  "Take a look at how we teach, syllabus, results and many more things."
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item} component={Link} href="/extra-curricular">
              <Box
                component="img"
                src="/sports.png"
                alt="sports"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                Extra Curriculars
              </Typography>
              <Typography variant="h5" align='center'>
                {
                  "Activities to help students explore their interests beyond academics."
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item} component={Link} href="/miscellaneous">
              <Box
                component="img"
                src="/light-bulb.png"
                alt="brain-bulb"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                Miscellaneous
              </Typography>
              <Typography variant="h5" align='center'>
                {"The extra effort our students take beyond the generic syllabus."}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
